import { render, staticRenderFns } from "./constructor.vue?vue&type=template&id=2d22ef5a"
import script from "./constructor.vue?vue&type=script&lang=ts"
export * from "./constructor.vue?vue&type=script&lang=ts"
import style0 from "./constructor.vue?vue&type=style&index=0&id=2d22ef5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports